module.exports = __webpack_public_path__ + "img/loginBackground.660b04cd.jpg";